"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EUDomainNames = [
    "crm4.omnichannelengagementhub.com",
    "crm12.omnichannelengagementhub.com",
    "crm16.omnichannelengagementhub.com",
    "crm17.omnichannelengagementhub.com",
    "crm19.omnichannelengagementhub.com",
    "crm11.omnichannelengagementhub.com",
    "eu.omnichannelengagementhub.com",
    "fr.omnichannelengagementhub.com",
    "de.omnichannelengagementhub.com",
    "ch.omnichannelengagementhub.com",
    "uk.omnichannelengagementhub.com" // UK
];
exports.default = EUDomainNames;
//# sourceMappingURL=EUDomainNames.js.map